import { ContactType } from "types/contact";

export interface CustomerServiceItem {
  name: string;
  path: string;
  position: string;
  value?: string;
  isQRCode?: boolean;
  disable?: boolean;
}

const normalizePlatform = (platform: string) =>
  platform
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

const buildTelegramValue = (url: string, hasApiUrl: boolean) => {
  if (!hasApiUrl) {
    return "---";
  }

  try {
    const pathname = new URL(url).pathname.replace(/\//g, "");
    return pathname ? `ID: ${pathname}` : "---";
  } catch (error) {
    return "---";
  }
};

const buildViberValue = (url: string, hasApiUrl: boolean) => {
  if (!hasApiUrl) {
    return "---";
  }
  const matchedPhone = url.match(/number=\+?(\d+)/i)?.[1];
  return matchedPhone ? `ID: +${matchedPhone}` : "---";
};

const getContactInfo = (
  contacts: ContactType[],
  platform: string,
) => {
  const matchedContact = contacts.find(
    (item) => normalizePlatform(item.Platform) === normalizePlatform(platform),
  );
  const url = matchedContact?.URL?.trim();

  if (!url || url === "-") {
    return {
      hasApiUrl: false,
      url: "",
    };
  }

  return {
    hasApiUrl: true,
    url,
  };
};

export const buildListServices = (
  contacts: ContactType[] = [],
): CustomerServiceItem[] => {
  const telegramContact = getContactInfo(contacts, "telegram");
  const viberContact = getContactInfo(contacts, "viber");
  const zaloContact = getContactInfo(contacts, "zalo");

  return [
    {
      name: "Telegram",
      path: telegramContact.url,
      value: buildTelegramValue(telegramContact.url, telegramContact.hasApiUrl),
      position: "-251px -746px",
      isQRCode: true,
    },
    {
      name: "Viber",
      path: viberContact.url,
      value: buildViberValue(viberContact.url, viberContact.hasApiUrl),
      position: "-201px -746px",
      isQRCode: true,
      disable: true,
    },
    {
      name: "Zalo",
      path: zaloContact.url,
      position: "-51px -745px",
    },
  ];
};
